import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import ScopeToggle from "../../components/ScopeToggle";
import MyTourPlanPage from "./MyTourPlanPage";
import TeamTourPlanPage from "./TeamTourPlanPage";
import AllTourPlansPage from "./AllTourPlansPage";

export default function TourPlansRouter() {
  const { user } = useAuth();
  const role = user?.role;
  const [scope, setScope] = useState("team");

  if (role === "sales_officer") return <MyTourPlanPage />;

  // Sales Manager only: a tour plan is field routing, and Admin Manager owns no
  // doctors, so their plan would be structurally empty.
  if (role === "assistant_manager") {
    return (
      <div className="space-y-6">
        <ScopeToggle scope={scope} onChange={setScope} testIdPrefix="tour-plans" />
        {scope === "me" ? <MyTourPlanPage /> : <TeamTourPlanPage />}
      </div>
    );
  }

  // Admin Manager keeps the team view they had before — they oversee plans but
  // never file one.
  if (role === "admin_manager") return <TeamTourPlanPage />;

  return <AllTourPlansPage />;
}
